import { Directive, TemplateRef } from '@angular/core';

/**
 * Use this directive for tab content that you want to lazy load only when that tab is active
 * Usage: `<ps-ui-tab><ng-template psUiTabContent><some-component></some-component></ng-template></ps-ui-tab-content>`
 */
@Directive({
  selector: '[psUiTabContent]',
})
export class TabContentDirective {
  constructor(public template: TemplateRef<any>) {}
}
